export default {
  state: {
    services: {
      show: false,
      startDate: '',
      endDate: '',
      id: '',
      saveBtn: true
    }
  },
  mutations: {
    setShowServiceAreaModal (state, value) { state.services.show = value },
    setStartDatePromo (state, value) { state.services.startDate = value },
    setEndDatePromo (state, value) { state.services.endDate = value },
    setServiceAreaID (state, value) { state.services.id = value },
    setSaveBtn (state, value) { state.services.saveBtn = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/geofences/geofence-servicearea.js